import { isPasswordValid } from '@lib/utils/formValidators'
import { validate } from 'email-validator'
import { TFunction } from 'next-i18next/pages'
import { LoginFormData, LoginFormErrors } from '../types'

interface ValidateResponse {
    errors: LoginFormErrors
    hasErrors: boolean
}

export const validateForm = (
    { email, password }: LoginFormData,
    t: TFunction
): ValidateResponse => {
    const errors = {} as LoginFormErrors

    if (!email) {
        errors.email = t('authErrors|Required')
    } else if (!validate(email)) {
        errors.email = t('authErrors|Invalid Email')
    }

    if (!password) {
        errors.password = t('authErrors|Required')
    } else if (!isPasswordValid(password)) {
        errors.password = t('authErrors|Invalid Password')
    }

    return { errors, hasErrors: Object.keys(errors).length !== 0 }
}
